import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * AuthCallback — handles cross-app auto-login from the landing page checkout.
 * URL format: /auth/callback?token=xxx&user={encodedJSON}
 *
 * Stores the token + user in localStorage and redirects to /app/.
 */
const AuthCallback = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');

    if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));

        // Validate that user has admin access
        const adminRoles = ['admin', 'super_admin', 'manager'];
        if (!adminRoles.includes(user?.role)) {
          console.error('Non-admin user in auth callback');
          window.location.href = '/login?error=access_denied';
          return;
        }

        localStorage.setItem('admin_auth_token', token);
        localStorage.setItem('admin_user_data', JSON.stringify(user));

        // Use full page redirect so AuthProvider picks up the new localStorage values
        window.location.href = '/app/';
      } catch (e) {
        console.error('Auth callback parse error:', e);
        window.location.href = '/login?error=invalid_data';
      }
    } else {
      // No valid token — redirect to login
      window.location.href = '/login';
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
        <p className="mt-4 text-gray-500">Setting up your account…</p>
      </div>
    </div>
  );
};

export default AuthCallback;